export { default as EventsTemplate } from './EventsTemplate';
